import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { TREATMENTS, CLINIC } from '../data/content';

export default function BookAppointment() {
  const [form,setForm]=useState({name:'',phone:'',age:'',city:'',consultationType:'In-person (Bhopal)',concern:'Acne & Pimples',preferredTime:'Morning (11:00 AM – 3:00 PM)',message:''});
  const [submitted,setSubmitted]=useState(false);
  const handle=e=>setForm({...form,[e.target.name]:e.target.value});

  const handleSubmit=e=>{
    e.preventDefault();
    const msg=encodeURIComponent(
      `🌿 *Appointment Request — Vaidyam Ayurveda*\n\n`+
      `👤 *Name:* ${form.name}\n`+
      `📞 *Phone:* ${form.phone}\n`+
      `🎂 *Age:* ${form.age||'Not specified'}\n`+
      `🏙️ *City:* ${form.city||'Bhopal'}\n`+
      `🏥 *Consultation:* ${form.consultationType}\n`+
      `🕐 *Preferred Time:* ${form.preferredTime}\n`+
      `⚕️ *Concern:* ${form.concern}\n`+
      `📝 *Message:* ${form.message||'No additional details'}`
    );
    window.open(`https://wa.me/${CLINIC.whatsapp}?text=${msg}`,'_blank');
    setSubmitted(true);
  };

  const inp={width:'100%',padding:'12px 14px',border:'1px solid rgba(255,255,255,0.08)',borderRadius:'3px',fontSize:'14px',background:'#1E1108',color:'#F0E6D8',outline:'none',fontFamily:'DM Sans, sans-serif',transition:'border-color 0.2s'};

  return (
    <div style={{background:'#1E1108',paddingTop:'68px',minHeight:'100vh'}}>
      <Helmet>
        <title>Book Appointment | Book Online Ayurveda Consultation</title>
        <meta name="description" content="Book your Ayurvedic consultation with Dr. Monika Jain in Bhopal. In-person or online. We confirm within minutes."/>
      </Helmet>

      <div style={{position:'relative',height:'300px',overflow:'hidden'}}>
        <img src="https://ik.imagekit.io/gnzsnmo3fr/vaidyam/hero/consultationhero.png" alt="" style={{width:'100%',height:'100%',objectFit:'cover',filter:'brightness(0.25)'}}/>
        <div style={{position:'absolute',inset:0,background:'linear-gradient(to top,#1E1108,transparent 60%)'}}/>
        <div style={{position:'absolute',inset:0,display:'flex',alignItems:'flex-end',padding:'0 48px 48px'}}>
          <div style={{maxWidth:'1280px',margin:'0 auto',width:'100%',textAlign:'center'}}>
            <span style={{fontSize:'10px',letterSpacing:'3px',color:'#C8941A',textTransform:'uppercase',fontWeight:500,display:'block',marginBottom:'12px'}}>Appointments</span>
            <h1 style={{fontFamily:'Cormorant Garamond, serif',fontSize:'52px',color:'#F0E6D8',lineHeight:1.05,marginBottom:'10px'}}>Begin Your Healing Journey</h1>
            <p style={{fontSize:'15px',color:'rgba(240,230,216,0.45)',maxWidth:'460px',margin:'0 auto',lineHeight:1.8}}>In-person at Bhopal or online from anywhere. We'll reach out within minutes.</p>
          </div>
        </div>
      </div>

      <div style={{padding:'60px 48px 100px'}}>
        <div style={{maxWidth:'680px',margin:'0 auto'}}>
          {/* Form — centered */}
          <div style={{background:'#261408',borderRadius:'4px',padding:'40px',border:'1px solid rgba(255,255,255,0.07)',marginBottom:'48px'}}>
            {!submitted ? (
              <form onSubmit={handleSubmit}>
                <h2 style={{fontFamily:'Cormorant Garamond, serif',fontSize:'28px',color:'#F0E6D8',marginBottom:'24px',textAlign:'center'}}>Request Appointment</h2>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'14px',marginBottom:'14px'}}>
                  {[['name','Full Name *','text',true],['phone','Phone *','tel',true],['age','Age','number',false],['city','City','text',false]].map(([name,label,type,req])=>(
                    <div key={name}>
                      <label style={{fontSize:'11px',color:'rgba(200,148,26,0.7)',letterSpacing:'0.5px',display:'block',marginBottom:'6px',textTransform:'uppercase'}}>{label}</label>
                      <input required={req} type={type} name={name} value={form[name]} onChange={handle} style={inp}
                        onFocus={e=>e.target.style.borderColor='rgba(200,148,26,0.5)'}
                        onBlur={e=>e.target.style.borderColor='rgba(255,255,255,0.08)'}
                      />
                    </div>
                  ))}
                  <div>
                    <label style={{fontSize:'11px',color:'rgba(200,148,26,0.7)',letterSpacing:'0.5px',display:'block',marginBottom:'6px',textTransform:'uppercase'}}>Consultation Type</label>
                    <select name="consultationType" value={form.consultationType} onChange={handle} style={inp}>
                      <option>In-person (Bhopal)</option>
                      <option>Online Video Call</option>
                      <option>WhatsApp Consultation</option>
                    </select>
                  </div>
                  <div>
                    <label style={{fontSize:'11px',color:'rgba(200,148,26,0.7)',letterSpacing:'0.5px',display:'block',marginBottom:'6px',textTransform:'uppercase'}}>Preferred Time</label>
                    <select name="preferredTime" value={form.preferredTime} onChange={handle} style={inp}>
                      <option>Morning (11:00 AM – 3:00 PM)</option>
                      <option>Evening (6:30 PM – 8:30 PM)</option>
                      <option>Any available slot</option>
                    </select>
                  </div>
                  <div style={{gridColumn:'1/-1'}}>
                    <label style={{fontSize:'11px',color:'rgba(200,148,26,0.7)',letterSpacing:'0.5px',display:'block',marginBottom:'6px',textTransform:'uppercase'}}>Primary Concern</label>
                    <select name="concern" value={form.concern} onChange={handle} style={inp}>
                      {TREATMENTS.map(t=><option key={t.id}>{t.name}</option>)}
                      <option>Panchakarma Detox</option>
                      <option>Swarna Prashan</option>
                      <option>General Consultation</option>
                      <option>Other</option>
                    </select>
                  </div>
                  <div style={{gridColumn:'1/-1'}}>
                    <label style={{fontSize:'11px',color:'rgba(200,148,26,0.7)',letterSpacing:'0.5px',display:'block',marginBottom:'6px',textTransform:'uppercase'}}>Message (optional)</label>
                    <textarea name="message" value={form.message} onChange={handle} rows={3} placeholder="Tell us more about your concern..." style={{...inp,resize:'vertical',minHeight:'80px'}}
                      onFocus={e=>e.target.style.borderColor='rgba(200,148,26,0.5)'}
                      onBlur={e=>e.target.style.borderColor='rgba(255,255,255,0.08)'}
                    />
                  </div>
                </div>
                <button type="submit" className="btn-gold" style={{width:'100%',justifyContent:'center',fontSize:'14px',padding:'14px'}}>
                  Send Request via WhatsApp →
                </button>
                <p style={{fontSize:'12px',color:'rgba(240,230,216,0.25)',textAlign:'center',marginTop:'12px',lineHeight:1.6}}>We will call you back within minutes to confirm. 🌿</p>
              </form>
            ) : (
              <div style={{textAlign:'center',padding:'40px 0'}}>
                <div style={{fontSize:'56px',marginBottom:'20px'}}>🌿</div>
                <h2 style={{fontFamily:'Cormorant Garamond, serif',fontSize:'32px',color:'#F0E6D8',marginBottom:'14px'}}>Request Sent!</h2>
                <p style={{fontSize:'15px',color:'rgba(240,230,216,0.5)',lineHeight:1.8,marginBottom:'24px'}}>Thank you, {form.name}! Our team will confirm your appointment within minutes.</p>
                <button onClick={()=>setSubmitted(false)} className="btn-ghost">Submit Another Request</button>
              </div>
            )}
          </div>

          {/* How it works — below form */}
          <div>
            <h2 style={{fontFamily:'Cormorant Garamond, serif',fontSize:'32px',color:'#F0E6D8',marginBottom:'24px',textAlign:'center'}}>How It Works</h2>
            {[['📋','Fill the form','Share your name, contact, concern and preferred slot'],['💬','We WhatsApp you','Our team reaches out within minutes to confirm'],['📅','Consultation confirmed','We set your exact date, time and consultation type together']].map(([icon,title,desc])=>(
              <div key={title} style={{display:'flex',gap:'18px',marginBottom:'20px',padding:'20px',background:'#261408',borderRadius:'3px',border:'1px solid rgba(255,255,255,0.05)'}}>
                <div style={{fontSize:'26px',flexShrink:0}}>{icon}</div>
                <div>
                  <div style={{fontWeight:500,color:'#F0E6D8',marginBottom:'4px',fontSize:'15px'}}>{title}</div>
                  <div style={{fontSize:'13px',color:'rgba(240,230,216,0.4)',lineHeight:1.7}}>{desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
